export default __webpack_public_path__ + "static/media/agricultureLogo.a4f813b8.png";